import { RouteProps } from '../../routes/AppRouter'
import { SubClinicsTable } from '../../features/clients'
import { Title } from '../../components/common/Title'

export const SubTable = (props: RouteProps) => {
  return (
    <>
      <Title color={"black"} title={props.title || ''} />
      <SubClinicsTable id={props.id} />
    </>
  )
}
